import React, { Component } from 'react';

//views
import CariAppFormLayoutRouting from "./form/CariAppFormLayoutRouting";
import NavSideBar from "../../../../../generic_components/components/nav_bars/NavSidebar";
import ContinuingPositionsHome from "../../cari_home_view/container/ContinuingPositionsHomeContainer";
import CariAppFormConsentLayout from "./form/CariAppFormConsentLayout";
// import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";
// import CariAppFormNavBtnBar from "../../../../components/cari_app_form_components/CariAppFormNavBtnBar";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../../functions/generic_functions";

//router
import { 
    Route, 
    Switch ,
    Redirect,
} from 'react-router-dom';

//static routes
import { 
    cari_app_form_pg_1_url,
    cari_app_form_pg_2_url,
    cari_app_form_pg_3_url,
    cari_app_form_pg_4_url,
    cari_api_save_form_page_base_url,
    cari_app_form_consent_url,
    cari_home_pg_url,
    cari_app_form_url,
    cari_logged_in_nav_bar, //TODO remove
    cari_logged_in_production_nav_bar
} 
from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    openCariModal,
    setCariActiveUserData
} from "../../../../../redux/actions/indexActions";

//redux mappers
const mapStateToProps = state => {
    return {
        
        activeUserData: state.cariReducer.activeUserData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activePositionData: state.cariReducer.activePositionData,
        activeApplicationData: state.cariReducer.activeApplicationData,
        cariPage1Data: state.cariReducer.cariPage1Data,
        cariPage2Data: state.cariReducer.cariPage2Data,
        cariPage3Data: state.cariReducer.cariPage3Data,
        cariPage4Data: state.cariReducer.cariPage4Data,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};


class CariMainNavBarLayoutRouting extends Component {

    state = {
        mounted: false,
    }

    constructor(props) {
        super(props);

        //valid route rendering
        this.checkIfPositionDataExists = this.checkIfPositionDataExists.bind(this);
        this.checkIfApplicationDataExists = this.checkIfApplicationDataExists.bind(this);

        //save form data upon click of navbar
        this.callBackBeforeRedirectPgFunc = this.callBackBeforeRedirectPgFunc.bind(this);
    }

    //returns boolean if position data from redux store exists
    checkIfPositionDataExists() {
        if (!isEmpty(this.props.activePositionData)
            && !isEmpty(this.props.activePositionData.position_id)
            && !isEmpty(this.props.activePositionData.position_title)) {
            return true;
        }
        else {
            return false;
        }
    }

    //check if the application data specifically the application_id and application status exists in the redux store
    checkIfApplicationDataExists() {
        if (!isEmpty(this.props.activeApplicationData)
            && !isEmpty(this.props.activeApplicationData.application_id)
            && !isEmpty(this.props.activeApplicationData.application_status)) {
            return true;
        }
        else {
            return false;
        }
    }

    callBackBeforeRedirectPgFunc(nextUrl, fn) {

        //check what page it is currently on
        var currentPgLocation = this.props.location.pathname;

        //if the application completion status is "Complete", skip save page
        if (this.props.activeApplicationData.application_status === "Complete") {
            this.props.history.push(cari_home_pg_url);
            return;
        }

        //if the current location is one of the cari forms pg 1,2,3,4, and the destination is cari home page, do a save 
        if (cari_home_pg_url === nextUrl && (
            cari_app_form_pg_1_url === currentPgLocation
            || cari_app_form_pg_2_url === currentPgLocation
            || cari_app_form_pg_3_url === currentPgLocation
            || cari_app_form_pg_4_url === currentPgLocation)
        ) {

            //get current page num and data from redux store
            var cariPageDataCopy = null;
            var currentPageNum = null;
            switch(currentPgLocation) {
                case cari_app_form_pg_1_url: 
                    cariPageDataCopy = this.props.cariPage1Data;
                    currentPageNum = 1;
                    break;
                case cari_app_form_pg_2_url:
                    cariPageDataCopy = this.props.cariPage2Data;
                    currentPageNum = 2;
                    break;
                case cari_app_form_pg_3_url:
                    cariPageDataCopy = this.props.cariPage3Data;
                    currentPageNum = 3;
                    break;
                case cari_app_form_pg_4_url:
                    cariPageDataCopy = this.props.cariPage4Data;
                    currentPageNum = 4;
                    break;
                default: 
                    currentPageNum = null;
            }

            //if page 3, skip and go to next link
            if (currentPageNum === 3) {
                //redirect to next page
                this.props.history.push(nextUrl);
                return;
            }

            if (!isEmpty(cariPageDataCopy)) {

                //remove page num from post data
                delete cariPageDataCopy['page_num'];

                //post url
                var savePageDataUrl = cari_api_save_form_page_base_url + currentPageNum;

                //get email and application id and post data to post 
                var currentEmail = this.props.activeVerifiedLoginUserData.email;
                var currentApplicationId = this.props.activeApplicationData.application_id;
                var currentToken = this.props.activeVerifiedLoginUserData.token;

                //set post data and add email, token and application id
                var form_data = new FormData();
                form_data.append("email", currentEmail);
                form_data.append("application_id", currentApplicationId);
                form_data.append("token", currentToken);
                form_data.append("postData", JSON.stringify(cariPageDataCopy));

                var usedOwnEmailAsReference = false;

                for(var i = 0; i < cariPageDataCopy.length; i++) {
                    if(cariPageDataCopy[i]['email'] == currentEmail) {
                        usedOwnEmailAsReference = true;
                    }
                }

                if(usedOwnEmailAsReference) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Invalid Email Address",
                        contentText: "You may not use your own email address for a reference. Please enter your reference's email address."
                    });
                }
                else {
                    //fetch page data from parameters
                    fetch(savePageDataUrl, {
                        method: 'POST',
                        body: form_data,
                        headers: {
                            'Accept': 'application/json',
                        }
                    }).then((response) => {
                        //only continue fetch if mounted
                        if (this.state.mounted) {
                            var responseHttpCode = response.status;
                            //good request
                            if (responseHttpCode === 200) {
                                return response.json();
                            }
                            //404 api not found, allows user to retry
                            else if (responseHttpCode === 404) {
                                this.props.openCariModal({
                                    modalId: "errorModal",
                                    title: "Bad Request, please try again.",
                                });
                            }
                            //invalid data and not authorized, reset cari data
                            else {
                                this.props.openCariModal({
                                    modalId: "errorModal",
                                    title: "User Session is invalid or has expired, please login again.",
                                    callBackFuncOnOk: () => {
                                        this.props.resetCariActiveData();
                                    }
                                });
                            }
                        }
                    }).then(json => {
                        //successfully processed request
                        if (!isEmpty(json)
                            && !isEmpty(json.status)
                            && json.status 
                            && !isEmpty(JSON.parse(json.message))
                            && JSON.parse(json.message).saveComplete
                        ) {
                            var json_data = JSON.parse(json.message);

                            //save first name and last name to redux store for active user data if it is the first page and the first name and last name is not empty
                            if (currentPageNum === 1
                                && !isEmpty(cariPageDataCopy.first_name)
                                && !isEmpty(cariPageDataCopy.last_name)
                            ) {
                                var copyUserActiveData = cloneObject(this.props.activeUserData);
                                copyUserActiveData.first_name = cariPageDataCopy.first_name;
                                copyUserActiveData.last_name = cariPageDataCopy.last_name;
                                this.props.setCariActiveUserData(copyUserActiveData);
                            }

                            //redirect page
                            fn(nextUrl);
                        }
                        else {
                            console.log("Failed to save page data");
                            //redirect page
                            fn(nextUrl);
                        }
                    })
                    //if api is not found
                    .catch((error) => {
                        console.log(error);

                        //redirect page
                        fn(nextUrl);
                    });
                }
            }
        }
        else {
            //redirect page
            fn(nextUrl);
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() {
        return (  
            <div>
                <div className="p-grid">  
                    <div className="p-col-2">
                        <NavSideBar 
                            callBackBeforeRedirectPgFunc={this.callBackBeforeRedirectPgFunc}
                            navBarOptions={cari_logged_in_production_nav_bar}
                        />
                    </div>
                    <div className="p-col-10">
                        <Switch>

                            {(this.checkIfPositionDataExists()) ?
                                <Route
                                    exact
                                    path={cari_app_form_consent_url}
                                    component={CariAppFormConsentLayout}
                                />
                                : null
                            }

                            {(this.checkIfPositionDataExists() && this.checkIfApplicationDataExists()) ?
                                <Route
                                    path={cari_app_form_url}
                                    component={CariAppFormLayoutRouting}
                                />
                                : null
                            }

                            <Route
                                exact
                                path={cari_home_pg_url}
                                component={ContinuingPositionsHome}
                            />

                            <Redirect
                                from='*'
                                to={cari_home_pg_url}
                            />
                        </Switch>

                        {/* <CariMainPgFooterView /> */}
            
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CariMainNavBarLayoutRouting);
